import en from './en/index';
import pl from './pl/index';

export const messages = {
  en,
  pl,
};
